import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchGenerationResult } from '@/services/generationResult';

export function useGenerationResultQuery(generationId: string) {
  const { status } = useAuthSession();

  return useQuery({
    queryKey: ['generation', generationId],
    queryFn: () => fetchGenerationResult(generationId),
    enabled: status === 'ready',
  });
}
